module.exports = __webpack_public_path__ + "static/media/InconsolataRegular.8a1996c4.woff";